export function isNotEmpty(xs: TODOAny) {
  return xs && xs.length !== 0
}
